import { CmsPrescriptionEntryKeys } from './cms.js';

function isCmsPrescriptionEntryKey(key) {
    return CmsPrescriptionEntryKeys.includes(key);
}

export { isCmsPrescriptionEntryKey };
//# sourceMappingURL=typeguards.js.map
